/**
 * useTrending hook
 *
 * TanStack Query hook for fetching trending tokens.
 * Uses a short staleTime (30s) since the KV cache handles server-side staleness.
 *
 * Story 3.5 — Task 1
 */

import { useQuery } from "@tanstack/react-query";

import { tokensApi } from "../lib/api";
import { tokenKeys } from "./api/query-keys";

const TRENDING_STALE_TIME_MS = 30_000;

export function useTrending(limit = 10) {
	return useQuery({
		queryKey: tokenKeys.trending(limit),
		queryFn: () => tokensApi.trending(limit),
		staleTime: TRENDING_STALE_TIME_MS,
	});
}
